import { useEffect, useState } from "react";
import { Button, Input, InputGroup, InputGroupText, Spinner } from "reactstrap"
import { FIELD_TYPES, FieldItem } from "../fields";
import { getUniqueData } from "../../components/dataCollection/apiController";
import useFieldItem from "../fields/UseFieldItem";
import { CustomButton } from "../button";
import { useDispatch } from "react-redux";
import { setLoading } from "../../store/slices/auth";
import { Flex, Spin } from "antd";

export const ColumnFilterUnique = ({ formId, getSearchText, column, previousData, applyFilter, onCancel }) => {
    const { filtervalue, setFilter } = column;
    const [dataVal, setData] = useState([]);
    const [dataAllVal, setAllData] = useState([]);
    const [values, fields, handleChange, { validateValues, updateValue }] = useFieldItem({}, {}, { onValueChange });

    const [load, setLoad] = useState(false);

    useEffect(() => {
    }, [load])
    /**
    * @param name 
    * @param value 
    * @param values 
    * @param fieldValues 
    * @returns 
    */
    function onValueChange(name, value, values, fieldValues = null) {
        let resetValue = {};
        console.log(column)
        //console.log(formTemplates)
        getSearchText(column, value)
        return [{
            ...values,
            ...resetValue,
            [name]: value,
        }]
    }


    useEffect(() => {
        console.log("--->", previousData)
        if (previousData && previousData.filter(item => item.field_id === column.data.id).length > 0) {
            let prevData = previousData.filter(item => item.field_id === column.data.id)[0].search_value;
            updateValue({
                'filterdata': prevData
            })
        }
        column.data && getUniquesValues(column.data.id)
    }, [])

    //console.log("--->",column,previousData)

    /**
     * fetcj unique values from column
     */
    const getUniquesValues: any = async (recordid) => {
        // console.log(recordid)
        try {
            setLoad(true)
            let data = await getUniqueData(formId, recordid)
            console.log(column.data.field_type)
            setAllData(data.data)
            const objectArray = data && data.data.map(item => ({
                label: column.data.field_type == "number" ? parseInt(item) : item,
                value: column.data.field_type == "number" ? parseInt(item) : item
            }));
            console.log(objectArray)
            setData(objectArray)
            setLoad(false)

        } catch (error) {
            setLoad(false)

        }
    }

    const selectAll = () =>{
        updateValue({filterdata:dataAllVal})
        getSearchText(column, dataAllVal)
    }

    const clearAll = () =>{
        updateValue({filterdata:[]})
        getSearchText(column, [])
    }

    useEffect(() => {

    }, [dataVal])

    return (


        <div className="custom-search-container">
            <div className="d-flex p-2">
                <span style={{color:'blue', fontWeight:'500',cursor:'pointer'}} onClick={() => selectAll()}><u>Select all {dataVal && dataVal.length} </u></span>
                <span style={{fontWeight:'500'}} className="pl-1 pr-2"> - </span>
                <span style={{color:'blue', fontWeight:'500',cursor:'pointer'}} onClick={() => clearAll()}><u>Clear</u></span>
            </div>
            {
                !load ?
                    <div className="filter-data" >

                        <div className="filter-item" >
                            <FieldItem
                                name={'filterdata'}
                                type={FIELD_TYPES.CHECK_BOX}
                                value={values['filterdata']}
                                values={dataVal && dataVal}
                                onChange={(...e) => handleChange('filterdata', ...e)}
                            />

                        </div>
                        <div className="footer-data">
                            <Button className="cancel" onClick={() => onCancel()}>Cancel</Button>
                            <Button className="apply" onClick={() => applyFilter("array")}>Apply</Button>

                        </div>


                    </div>
                    :
                    <Flex align="center" gap="middle">
                        <Spin />Loading...
                    </Flex>
            }
        </div>
    )
}